import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-script',
  templateUrl: './script.component.html',
  styleUrls: ['./script.component.scss']
})
export class ScriptComponent implements OnInit {
  tTitle: any = '';
  nList:any;
  wContent: any [] = [
    {
      title: '',
      image: '',
      content: '',
    },
  ];
  na = 0;
  url = this.api.url;
  wImages: any;
  ia = 0;
  aImage: any;
  constructor(private api: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.GetData(this.router.url);
  }
  GetData(url: any) {
    if(url === '/chubanlishi') {
      this.tTitle = 'ᠮᠣᠩᠭᠣᠯ ᠪᠠᠷ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠲᠡᠦᠬᠡ';
      this.GetMTaxonomy('menggushuTaxonomy');
    } else if (url === '/newspaper') {
      this.tTitle = 'ᠮᠣᠩᠭᠣᠯ ᠰᠣᠨᠢᠨ ᠰᠡᠳᠬᠦᠯ ᠦᠨ ᠲᠡᠦᠬ';
      this.GetMTaxonomy('NewspaperTaxonomy');
    } else if (url === '/zilishi') {
      this.tTitle = 'ᠮᠣᠩᠭᠣᠯ ᠦᠰᠦᠭ ᠪᠢᠴᠢᠭ ᠦᠨ ᠲᠡᠦᠬᠡ';
      this.GetMTaxonomy('mengguzilishiTaxonomy');
    } else {
      console.log('Error! router.url Error.')
    }
  }
  GetMTaxonomy(link: any) {
    this.api.GetMTaxonomy(link).subscribe(
      data => {
        this.nList = data;
        this.GetWriting(data[0].taxonomyId);
      }
    )
  }
  GetWriting(id: any) {
    this.api.GetWriting(id).subscribe(
      data => {
        if (data.length !== 0) {
          this.wContent = data;
          this.wImages = data[0].image;
          if(data[0].image.length === 0) {
            this.aImage = '';
          } else {
            this.aImage = data[0].image[0].path;
          }
        } 
        
      }
    )
  }
  navActive(id: any, i: any) {
    this.na = i;
    this.GetWriting(id);
  }
  iActive(i: any, image: any) {
    this.ia = i;
    this.aImage = image;
  } 
  
}
